import { HTTP_INTERCEPTORS, HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { delay, dematerialize, map, materialize, mergeMap } from 'rxjs/operators';
import { Role } from 'shared/src/app/types/user';

@Injectable()
export class FakeBackendInterceptor implements HttpInterceptor {
  constructor(private readonly _http: HttpClient) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const users = [
      { id: 1, username: 'admin@gmail.com', password: '123456', firstName: 'Admin', lastName: 'User', role: Role.Admin, token: 'abc', isEulaAccepted: true },
      { id: 2, username: 'user@gmail.com', password: '123456', firstName: 'Normal', lastName: 'User', role: Role.User, token: 'xyz', isEulaAccepted: true },
      { id: 3, username: 'user1@gmail.com', password: '123456', firstName: 'Normal1', lastName: 'User1', role: Role.User, token: 'xyz1', isEulaAccepted: false }
    ];

    const authHeader = request.headers.get('Authorization');
    const isLoggedIn = authHeader && authHeader.startsWith('Bearer fake-jwt-token');
    // wrap in delayed observable to simulate server api call
    return of(null).pipe(mergeMap(() => {
      // login - public
      if (request.url.endsWith('/Authorize') && request.method === 'POST') {
        const user = users.find(x => x.username === request.body.username && x.password === request.body.password);
        if (!user) {
          return error('Username or password is incorrect');
        } else if (!user.isEulaAccepted) {
          return error('EULA not accepted.');
        }

        // const data = {
        //   id: user.id,
        //   username: user.username,
        //   firstName: user.firstName,
        //   lastName: user.lastName,
        //   token: user.token,
        //   role: user.role
        // };

        const data = {
          'Status': true,
          'Message': null,
          'MessageValue': null,
          'CustomerNumber': null,
          'ReturnData': {
            'redirect': true,
            'url': '/Company/Book/ManageBookCategories',
            'action': 'ManageBookCategories',
            'controller': 'Book',
            'area': 'Company'
          },
          'OtherData': null,
          'CountryId': 0,
          'StateId': 0,
          'NoOfDays': 0,
          'NoOfTrucks': null,
          'OptionNoOfDays': 0,
          'IsCategoryImages': 0,
          'IsSubCategoryImages': 0,
          'Ismarketing': 0,
          'MarketingNotes': 0,
          'Trade1': null,
          'Trade2': null,
          'Trade3': null,
          'Discount': 0,
          'TotalWithDiscount': 0,
          'CreditCardId': 0,
          'IsBundleBoards': 0,
          'PurchaseOption': null,
          'IsLoadedInstall': false,
          'IsUserBundleBoard': false,
          'TermAccepted': false,
          'ActivePaidUsersCount': 0,
          'IsTradesLoaded': false,
          'ImageURL': null,
          'ImageFileName': null,
          'IsLoadTradeIsScheduled': false,
          'token': 'abc'
        };

        return ok(data);
      }

      // validate_token - public
      if (request.url.match(/\/validate_token\/\S+$/) && request.method === 'GET') {

        // get id from request url
        const urlParts = request.url.split('/');
        const token = urlParts[urlParts.length - 1];
        const user = users.find(x => x.token === token);
        if (!user) { return error('Invalid Token'); }
        const data = true;
        return ok(data);
      }

      // Terms of serice
      if (request.url.endsWith('/terms_of_service') && request.method === 'GET') {
        return this._http.get('./assets/html/terms-of-service.html', { responseType: 'text' }).pipe(map((res) => {
          return new HttpResponse({
            status: 200, body: {
              Status: true,
              Message: 'Success',
              ReturnData: {
                isHtml: true,
                content: res
              }
            }
          });
        }));
      }

      // Logout
      if (request.url.endsWith('/home/logout') && request.method === 'GET') {
        const data = {
          'Status': true,
          'Message': 'Successfully Logout',
        };

        return ok(data);
      }

      // Forgot Password
      if (request.url.endsWith('/UserModules') && request.method === 'GET') {


        const data = {
          'Status': true,
          'Message': 'Success',

            'menues': [
              {
                'displayName': 'Business Information',
                'type': 'Upper',
                'liClick': '',
                'icon': 'BusinessInformationxzIcon',
                'linkURL': '/Company/Company/ManageBusinessInformation',
                'actionName': 'ManageBusinessInformation',
                'controllerName': 'Company',
                'areaName': 'Company',
                'canSync': 0,
                'canShow': true,
                'sortOrder': 1
              },
              {
                'displayName': 'Manage Book',
                'type': 'Upper',
                'liClick': '',
                'icon': 'BookIcon',
                'linkURL': '/Company/Book/ManageBookCategories',
                'actionName': 'ManageBusinessInformation',
                'controllerName': 'Company',
                'areaName': 'Company',
                'canSync': 1,
                'canShow': true,
                'sortOrder': 2
              },
              {
                'displayName': 'Tasks',
                'type': 'Upper',
                'liClick': '',
                'icon': 'TaskIcon',
                'linkURL': '/Company/Task/ManageTasks',
                'actionName': 'ManageTasks',
                'controllerName': 'Task',
                'areaName': 'Company',
                'canSync': 2,
                'canShow': true,
                'sortOrder': 3
              },
              {
                'displayName': 'Parts',
                'type': 'Upper',
                'liClick': '',
                'icon': 'PartsIcon',
                'linkURL': '/Company/Company/ManageParts',
                'actionName': 'ManageParts',
                'controllerName': 'Company',
                'areaName': 'Company',
                'canSync': 0,
                'canShow': true,
                'sortOrder': 4
              },
              {
                'displayName': 'Option Boards',
                'type': 'Upper',
                'liClick': '',
                'icon': 'OptionBuildeIcon',
                'linkURL': '/Company/Subscription/ManageBundleBoard',
                'actionName': 'ManageBundleBoard',
                'controllerName': 'Subscription',
                'areaName': 'Company',
                'canSync': 0,
                'canShow': true,
                'sortOrder': 5
              },
              {
                'displayName': 'Customers',
                'type': 'Upper',
                'liClick': '',
                'icon': 'UsersIcon',
                'linkURL': '/Company/Customer',
                'actionName': 'index',
                'controllerName': 'Customer',
                'areaName': 'Company',
                'canSync': 0,
                'canShow': true,
                'sortOrder': 6
              },
              {
                'displayName': 'Work Orders',
                'type': 'Upper',
                'liClick': '',
                'icon': 'InvoicesIcon',
                'linkURL': '/Company/WorkOrder',
                'actionName': 'index',
                'controllerName': 'WorkOrder',
                'areaName': 'Company',
                'canSync': 0,
                'canShow': true,
                'sortOrder': 7
              },
              {
                'displayName': 'Export/Import',
                'type': 'Upper',
                'liClick': '',
                'icon': 'ReportsIcon',
                'linkURL': '/Company/ReportandExport/ExportOrImport',
                'actionName': 'ExportOrImport',
                'controllerName': 'ReportandExport',
                'areaName': 'Company',
                'canSync': 0,
                'canShow': true,
                'sortOrder': 8
              },
              {
                'displayName': 'FieldEdge',
                'type': 'Lower',
                'liClick': '',
                'icon': 'MyAccountIcon',
                'linkURL': '/Company/Company/Dashboard',
                'actionName': 'Dashboard',
                'controllerName': 'Company',
                'areaName': 'Company',
                'canSync': 1,
                'canShow': true,
                'sortOrder': 2
              },
              {
                'displayName': 'My Account',
                'type': 'Lower',
                'liClick': '',
                'icon': 'MyAccountIcon',
                'linkURL': '/Company/Company/Dashboard',
                'actionName': 'Dashboard',
                'controllerName': 'Company',
                'areaName': 'Company',
                'canSync': 0,
                'canShow': true,
                'sortOrder': 2
              },
              {
                'displayName': 'Settings',
                'type': 'Lower',
                'liClick': '',
                'icon': 'SettingsIcon',
                'linkURL': '/Company/Subscription/ManageSubscription',
                'actionName': 'ManageSubscription',
                'controllerName': 'Subscription',
                'areaName': 'Company',
                'canSync': 0,
                'canShow': true,
                'sortOrder': 3
              }
            ]
        };

        return ok(data);
      }

      // GetLoginDetails
      if (request.url.endsWith('/GetLoginDetails') && request.method === 'POST') {

        const user = users.find(x => x.username === request.body.username && x.password === request.body.password);
        if (!user) {
          return error('Username or password is incorrect');
        } else if (!user.isEulaAccepted) {
          return error('EULA not accepted.');
        }

        const data = {
          'Status': false,
          'Message': 'Invalid Username/Password',
          'MessageValue': null,
          'CustomerNumber': null,
          'ReturnData': null,
          'OtherData': 'Invalid Username/Password',
          'CountryId': 0,
          'StateId': 0,
          'NoOfDays': 0,
          'NoOfTrucks': null,
          'OptionNoOfDays': 0,
          'IsCategoryImages': 0,
          'IsSubCategoryImages': 0,
          'Ismarketing': 0,
          'MarketingNotes': 0,
          'Trade1': null,
          'Trade2': null,
          'Trade3': null,
          'Discount': 0,
          'TotalWithDiscount': 0,
          'CreditCardId': 0,
          'IsBundleBoards': 0,
          'PurchaseOption': null,
          'IsLoadedInstall': false,
          'IsUserBundleBoard': false,
          'TermAccepted': false,
          'ActivePaidUsersCount': 0,
          'IsTradesLoaded': false,
          'ImageURL': null,
          'ImageFileName': null,
          'IsLoadTradeIsScheduled': false
        };

        return ok(data);
      }

      if (request.url.endsWith('/Part_Task_Assignments') && request.method === 'POST') {
          const partTaskAssignments = {
            'part_task_assignments': [
              {
                'id': 10,
                'item': 'Item 1',
                'duration': 3.00,
                'name': '#10 Humidifier Panel',
                'trade': 'Heating',
                'valueRate': 37.00,
                'standardRate': 37.00,
                'premiumRate': 37.00
              },
              {
                'id': 11,
                'item': 'Item 1',
                'duration': 3.00,
                'name': '#10 Humidifier Panel',
                'trade': 'Heating',
                'valueRate': 37.00,
                'standardRate': 37.00,
                'premiumRate': 37.00
              },
              {
                'id': 12,
                'item': 'Item 1',
                'duration': 3.00,
                'name': '#10 Humidifier Panel',
                'trade': 'Heating',
                'valueRate': 37.00,
                'standardRate': 37.00,
                'premiumRate': 37.00
              },
              {
                'id': 13,
                'item': 'Item 1',
                'duration': 3.00,
                'name': '#10 Humidifier Panel',
                'trade': 'Heating',
                'valueRate': 37.00,
                'standardRate': 37.00,
                'premiumRate': 37.00
              },
              {
                'id': 14,
                'item': 'Item 1',
                'duration': 3.00,
                'name': '#10 Humidifier Panel',
                'trade': 'Heating',
                'valueRate': 37.00,
                'standardRate': 37.00,
                'premiumRate': 37.00
              },
              {
                'id': 15,
                'item': 'Item 1',
                'duration': 3.00,
                'name': '#10 Humidifier Panel',
                'trade': 'Heating',
                'valueRate': 37.00,
                'standardRate': 37.00,
                'premiumRate': 37.00
              }
            ],
            'page': 1,
            'pageSize': 2147483647,
            'totalCount': 3352,
            'totalNumberOfPages': 1,
            'hasMore': true,
            'message': 'Success',
            'status': true
          };

          return ok(partTaskAssignments);
      }

      if (request.url.endsWith('/Partss') && request.method === 'POST') {
        if (request.body.skip === 1) {
          const parts = {
            'parts': [
              {
                'id': 836321108,
                'name': '#1022 HumidPan',
                'description': '#10 Humidifier Panel test',
                'productline': 'bbbb',
                'category': 'A/C Coils',
                'cost': 7,
                'issensitive': 'No',
                'IsActive': true,
                'markupexempt': 'Yes',
                'retailprice': 0,
                'mfGname': 'jjj',
                'mfgpart': '',
                'upc': '5435435-4365465',
                'tradeservicepart': '',
                'vendorname': '',
                'vendorpart': '',
                'payscommision': 'Yes',
                'externalID': '',
                'account': '25',
                'createdDate': '16-04-2019 07:50:44',
                'lastUpdatedDate': '24-04-2019 05:49:43',
                'taskAssignments': [],
                'vendors': [
                  {
                    'id': 3459,
                    'vendorId': 34,
                    'isPrimary': false,
                    'memo': '',
                    'vendorPart': '',
                    'cost': 0,
                    'vendorName': 'qa'
                  },
                  {
                    'id': 30265,
                    'vendorId': 33,
                    'isPrimary': false,
                    'memo': '',
                    'vendorPart': '',
                    'cost': 22,
                    'vendorName': 'Vendor03'
                  },
                  {
                    'id': 31244,
                    'vendorId': 168,
                    'isPrimary': false,
                    'memo': '',
                    'vendorPart': '',
                    'cost': 0,
                    'vendorName': 'beeesolver'
                  },
                  {
                    'id': 42420,
                    'vendorId': 31,
                    'isPrimary': true,
                    'memo': '',
                    'vendorPart': '',
                    'cost': 7,
                    'vendorName': 'Vendor01'
                  },
                  {
                    'id': 49196,
                    'vendorId': 32,
                    'isPrimary': false,
                    'memo': '',
                    'vendorPart': '',
                    'cost': 7,
                    'vendorName': 'Vendor02'
                  },
                  {
                    'id': 52037,
                    'vendorId': 33,
                    'isPrimary': false,
                    'memo': '',
                    'vendorPart': '',
                    'cost': 22,
                    'vendorName': 'Vendor03'
                  },
                  {
                    'id': 55898,
                    'vendorId': 34,
                    'isPrimary': false,
                    'memo': '',
                    'vendorPart': '',
                    'cost': 0,
                    'vendorName': 'qa'
                  },
                  {
                    'id': 57645,
                    'vendorId': 101,
                    'isPrimary': false,
                    'memo': '',
                    'vendorPart': '',
                    'cost': 0,
                    'vendorName': 'test'
                  }
                ]
              }
            ],
            'page': 1,
            'pageSize': 2147483647,
            'totalCount': 3352,
            'totalNumberOfPages': 1,
            'hasMore': false,
            'message': 'Success',
            'status': true
          };

          return ok(parts);
        }

        const parts = {
          'parts': [
            {
              'id': 8363208,
              'name': '#10 HumidPan',
              'description': '#10 Humidifier Panel test',
              'productline': 'bbbb',
              'category': 'A/C Coils',
              'cost': 7,
              'issensitive': 'No',
              'IsActive': false,
              'markupexempt': 'Yes',
              'retailprice': 0,
              'mfGname': 'jjj',
              'mfgpart': '',
              'upc': '5435435-4365465',
              'tradeservicepart': '',
              'vendorname': '',
              'vendorpart': '',
              'payscommision': 'Yes',
              'externalID': '',
              'account': '25',
              'createdDate': '16-04-2019 07:50:44',
              'lastUpdatedDate': '24-04-2019 05:49:43',
              'taskAssignments': [],
              'vendors': [
                {
                  'id': 3459,
                  'vendorId': 34,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 0,
                  'vendorName': 'qa'
                },
                {
                  'id': 30265,
                  'vendorId': 33,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 22,
                  'vendorName': 'Vendor03'
                },
                {
                  'id': 31244,
                  'vendorId': 168,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 0,
                  'vendorName': 'beeesolver'
                },
                {
                  'id': 42420,
                  'vendorId': 31,
                  'isPrimary': true,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 7,
                  'vendorName': 'Vendor01'
                },
                {
                  'id': 49196,
                  'vendorId': 32,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 7,
                  'vendorName': 'Vendor02'
                },
                {
                  'id': 52037,
                  'vendorId': 33,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 22,
                  'vendorName': 'Vendor03'
                },
                {
                  'id': 55898,
                  'vendorId': 34,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 0,
                  'vendorName': 'qa'
                },
                {
                  'id': 57645,
                  'vendorId': 101,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 0,
                  'vendorName': 'test'
                }
              ]
            },
            {
              'id': 836344208,
              'name': '#10 HumidPan',
              'description': '#10 Humidifier Panel test',
              'productline': 'bbbb',
              'category': 'A/C Coils',
              'cost': 7,
              'issensitive': 'No',
              'IsActive': true,
              'markupexempt': 'Yes',
              'retailprice': 0,
              'mfGname': 'jjj',
              'mfgpart': '',
              'upc': '5435435-4365465',
              'tradeservicepart': '',
              'vendorname': '',
              'vendorpart': '',
              'payscommision': 'Yes',
              'externalID': '',
              'account': '25',
              'createdDate': '16-04-2019 07:50:44',
              'lastUpdatedDate': '24-04-2019 05:49:43',
              'taskAssignments': [],
              'vendors': [
                {
                  'id': 3459,
                  'vendorId': 34,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 0,
                  'vendorName': 'qa'
                },
                {
                  'id': 30265,
                  'vendorId': 33,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 22,
                  'vendorName': 'Vendor03'
                },
                {
                  'id': 31244,
                  'vendorId': 168,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 0,
                  'vendorName': 'beeesolver'
                },
                {
                  'id': 42420,
                  'vendorId': 31,
                  'isPrimary': true,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 7,
                  'vendorName': 'Vendor01'
                },
                {
                  'id': 49196,
                  'vendorId': 32,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 7,
                  'vendorName': 'Vendor02'
                },
                {
                  'id': 52037,
                  'vendorId': 33,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 22,
                  'vendorName': 'Vendor03'
                },
                {
                  'id': 55898,
                  'vendorId': 34,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 0,
                  'vendorName': 'qa'
                },
                {
                  'id': 57645,
                  'vendorId': 101,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 0,
                  'vendorName': 'test'
                }
              ]
            },
            {
              'id': 836324508,
              'name': '#10 HumidPan',
              'description': '#10 Humidifier Panel test',
              'productline': 'bbbb',
              'category': 'A/C Coils',
              'cost': 7,
              'issensitive': 'No',
              'IsActive': true,
              'markupexempt': 'Yes',
              'retailprice': 0,
              'mfGname': 'jjj',
              'mfgpart': '',
              'upc': '5435435-4365465',
              'tradeservicepart': '',
              'vendorname': '',
              'vendorpart': '',
              'payscommision': 'Yes',
              'externalID': '',
              'account': '25',
              'createdDate': '16-04-2019 07:50:44',
              'lastUpdatedDate': '24-04-2019 05:49:43',
              'taskAssignments': [],
              'vendors': [
                {
                  'id': 3459,
                  'vendorId': 34,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 0,
                  'vendorName': 'qa'
                },
                {
                  'id': 30265,
                  'vendorId': 33,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 22,
                  'vendorName': 'Vendor03'
                },
                {
                  'id': 31244,
                  'vendorId': 168,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 0,
                  'vendorName': 'beeesolver'
                },
                {
                  'id': 42420,
                  'vendorId': 31,
                  'isPrimary': true,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 7,
                  'vendorName': 'Vendor01'
                },
                {
                  'id': 49196,
                  'vendorId': 32,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 7,
                  'vendorName': 'Vendor02'
                },
                {
                  'id': 52037,
                  'vendorId': 33,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 22,
                  'vendorName': 'Vendor03'
                },
                {
                  'id': 55898,
                  'vendorId': 34,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 0,
                  'vendorName': 'qa'
                },
                {
                  'id': 57645,
                  'vendorId': 101,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 0,
                  'vendorName': 'test'
                }
              ]
            },
            {
              'id': 8363248,
              'name': '#10 HumidPan',
              'description': '#10 Humidifier Panel test',
              'productline': 'bbbb',
              'category': 'A/C Coils',
              'cost': 7,
              'issensitive': 'No',
              'IsActive': true,
              'markupexempt': 'Yes',
              'retailprice': 0,
              'mfGname': 'jjj',
              'mfgpart': '',
              'upc': '5435435-4365465',
              'tradeservicepart': '',
              'vendorname': '',
              'vendorpart': '',
              'payscommision': 'Yes',
              'externalID': '',
              'account': '25',
              'createdDate': '16-04-2019 07:50:44',
              'lastUpdatedDate': '24-04-2019 05:49:43',
              'taskAssignments': [],
              'vendors': [
                {
                  'id': 3459,
                  'vendorId': 34,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 0,
                  'vendorName': 'qa'
                },
                {
                  'id': 30265,
                  'vendorId': 33,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 22,
                  'vendorName': 'Vendor03'
                },
                {
                  'id': 31244,
                  'vendorId': 168,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 0,
                  'vendorName': 'beeesolver'
                },
                {
                  'id': 42420,
                  'vendorId': 31,
                  'isPrimary': true,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 7,
                  'vendorName': 'Vendor01'
                },
                {
                  'id': 49196,
                  'vendorId': 32,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 7,
                  'vendorName': 'Vendor02'
                },
                {
                  'id': 52037,
                  'vendorId': 33,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 22,
                  'vendorName': 'Vendor03'
                },
                {
                  'id': 55898,
                  'vendorId': 34,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 0,
                  'vendorName': 'qa'
                },
                {
                  'id': 57645,
                  'vendorId': 101,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 0,
                  'vendorName': 'test'
                }
              ]
            },
            {
              'id': 8363201,
              'name': '#10 HumidPan',
              'description': '#10 Humidifier Panel test',
              'productline': 'bbbb',
              'category': 'A/C Coils',
              'cost': 7,
              'issensitive': 'No',
              'IsActive': true,
              'markupexempt': 'Yes',
              'retailprice': 0,
              'mfGname': 'jjj',
              'mfgpart': '',
              'upc': '5435435-4365465',
              'tradeservicepart': '',
              'vendorname': '',
              'vendorpart': '',
              'payscommision': 'Yes',
              'externalID': '',
              'account': '25',
              'createdDate': '16-04-2019 07:50:44',
              'lastUpdatedDate': '24-04-2019 05:49:43',
              'taskAssignments': [],
              'vendors': [
                {
                  'id': 3459,
                  'vendorId': 34,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 0,
                  'vendorName': 'qa'
                },
                {
                  'id': 30265,
                  'vendorId': 33,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 22,
                  'vendorName': 'Vendor03'
                },
                {
                  'id': 31244,
                  'vendorId': 168,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 0,
                  'vendorName': 'beeesolver'
                },
                {
                  'id': 42420,
                  'vendorId': 31,
                  'isPrimary': true,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 7,
                  'vendorName': 'Vendor01'
                },
                {
                  'id': 49196,
                  'vendorId': 32,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 7,
                  'vendorName': 'Vendor02'
                },
                {
                  'id': 52037,
                  'vendorId': 33,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 22,
                  'vendorName': 'Vendor03'
                },
                {
                  'id': 55898,
                  'vendorId': 34,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 0,
                  'vendorName': 'qa'
                },
                {
                  'id': 57645,
                  'vendorId': 101,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 0,
                  'vendorName': 'test'
                }
              ]
            },
            {
              'id': 7839599,
              'name': '#12 HumidPan test',
              'description': '#12 Humidifier Panel',
              'productline': 'CIF',
              'category': 'Cast Iron Fittings',
              'cost': 11,
              'issensitive': 'No',
              'IsActive': true,
              'markupexempt': 'Yes',
              'retailprice': 0,
              'mfGname': '',
              'mfgpart': '',
              'upc': '',
              'tradeservicepart': '',
              'vendorname': '',
              'vendorpart': '',
              'payscommision': 'Yes',
              'externalID': '',
              'account': '',
              'createdDate': '04-06-2018 12:07:21',
              'lastUpdatedDate': '05-03-2019 07:35:28',
              'taskAssignments': [
                {
                  'id': 23113719,
                  'href': '/Tasks?Taskid=8676529',
                  'qty': 1,
                  'status': 'Primary'
                },
                {
                  'id': 23970734,
                  'href': '/Tasks?Taskid=8675096',
                  'qty': 1,
                  'status': 'Primary'
                },
                {
                  'id': 24413690,
                  'href': '/Tasks?Taskid=9076668',
                  'qty': 1,
                  'status': 'Primary'
                },
                {
                  'id': 23970737,
                  'href': '/Tasks?Taskid=8675091',
                  'qty': 1,
                  'status': 'Primary'
                },
                {
                  'id': 23970739,
                  'href': '/Tasks?Taskid=8738181',
                  'qty': 1,
                  'status': 'Primary'
                },
                {
                  'id': 24082642,
                  'href': '/Tasks?Taskid=8982795',
                  'qty': 1,
                  'status': 'Primary'
                },
                {
                  'id': 24152026,
                  'href': '/Tasks?Taskid=9004603',
                  'qty': 1,
                  'status': 'Primary'
                },
                {
                  'id': 24413688,
                  'href': '/Tasks?Taskid=9076667',
                  'qty': 1,
                  'status': 'Primary'
                },
                {
                  'id': 24413693,
                  'href': '/Tasks?Taskid=9076669',
                  'qty': 1,
                  'status': 'Primary'
                },
                {
                  'id': 24413707,
                  'href': '/Tasks?Taskid=9076679',
                  'qty': 1,
                  'status': 'Primary'
                },
                {
                  'id': 24413711,
                  'href': '/Tasks?Taskid=9076680',
                  'qty': 1,
                  'status': 'Primary'
                },
                {
                  'id': 31011208,
                  'href': '/Tasks?Taskid=10874865',
                  'qty': 1,
                  'status': 'Primary'
                },
                {
                  'id': 31348541,
                  'href': '/Tasks?Taskid=11189684',
                  'qty': 1,
                  'status': 'Primary'
                }
              ],
              'vendors': [
                {
                  'id': 2846,
                  'vendorId': 34,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 0,
                  'vendorName': 'qa'
                },
                {
                  'id': 41687,
                  'vendorId': 31,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 11,
                  'vendorName': 'Vendor01'
                },
                {
                  'id': 47953,
                  'vendorId': 32,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 11,
                  'vendorName': 'Vendor02'
                },
                {
                  'id': 51559,
                  'vendorId': 33,
                  'isPrimary': true,
                  'memo': 'set primary',
                  'vendorPart': '#12 HumidPan',
                  'cost': 11,
                  'vendorName': 'Vendor03'
                },
                {
                  'id': 54400,
                  'vendorId': 34,
                  'isPrimary': false,
                  'memo': '',
                  'vendorPart': '',
                  'cost': 0,
                  'vendorName': 'qa'
                }
              ]
            },
          ],
          'page': 1,
          'pageSize': 2147483647,
          'totalCount': 3352,
          'totalNumberOfPages': 1,
          'hasMore': true,
          'message': 'Success',
          'status': true
        };

        return ok(parts);
      }

      // Get Part Category
      if (request.url.endsWith('/get_part_category') && request.method === 'GET') {
        const categories = {
          'categories': [
            {
              'id': 6291,
              'name': 'A/C Coils',
              'children': false,
              'thumb_image': '',
              'external_id': '',
              'account': '',
              'description': ''
            },
            {
              'id': 6290,
              'name': 'ACast Iron Fittings',
              'children': false,
              'thumb_image': '',
              'external_id': '',
              'account': '',
              'description': ''
            },
            {
              'id': 6292,
              'name': 'A/C Parts',
              'children': false,
              'thumb_image': '',
              'external_id': '',
              'account': '',
              'description': ''
            },
            {
              'id': 6293,
              'name': 'A/C Condensers',
              'children': false,
              'thumb_image': '',
              'external_id': '',
              'account': '',
              'description': ''
            },
            {
              'id': 6294,
              'name': 'A/C Repairs',
              'children': false,
              'thumb_image': '',
              'external_id': '',
              'account': '',
              'description': ''
            },
          ],
          'message': 'Success',
          'status': true
        };
        return ok(categories);
      }

      // Get Vendors Lists
      if (request.url.endsWith('/get_all_vendors') && request.method === 'GET') {
        const vendors = {
          'vendors': [
            {
              'id': 3459,
              'vendorId': 34,
              'isPrimary': false,
              'memo': 'abc',
              'vendorPart': '86543',
              'cost': 5,
              'vendorName': 'qa',
              'msrp': 100,
              'multiplier': 0.6
            },
            {
              'id': 30265,
              'vendorId': 33,
              'isPrimary': true,
              'memo': 'abc',
              'vendorPart': '76543',
              'cost': 22,
              'vendorName': 'Vendor03',
              'msrp': 100,
              'multiplier': 0.6
            },
            {
              'id': 31244,
              'vendorId': 168,
              'isPrimary': false,
              'memo': 'abc',
              'vendorPart': '73827',
              'cost': 4,
              'vendorName': 'beeesolver',
              'msrp': 100,
              'multiplier': 0.6
            },
            {
              'id': 42420,
              'vendorId': 31,
              'isPrimary': false,
              'memo': 'abc',
              'vendorPart': '98767',
              'cost': 7,
              'vendorName': 'Vendor01',
              'msrp': 100,
              'multiplier': 0.6
            },
            {
              'id': 49196,
              'vendorId': 32,
              'isPrimary': false,
              'memo': 'abc',
              'vendorPart': '98766',
              'cost': 7,
              'vendorName': 'Vendor02',
              'msrp': 100,
              'multiplier': 0.6
            },
            {
              'id': 52037,
              'vendorId': 33,
              'isPrimary': false,
              'memo': 'abc',
              'vendorPart': '34567',
              'cost': 22,
              'vendorName': 'Vendor03',
              'msrp': 100,
              'multiplier': 0.6
            },
            {
              'id': 55898,
              'vendorId': 34,
              'isPrimary': false,
              'memo': 'abc',
              'vendorPart': '87655',
              'cost': 2,
              'vendorName': 'qa',
              'msrp': 100,
              'multiplier': 0.6
            },
            {
              'id': 57645,
              'vendorId': 101,
              'isPrimary': false,
              'memo': 'abc',
              'vendorPart': '94567',
              'cost': 3,
              'vendorName': 'test',
              'msrp': 100,
              'multiplier': 0.6
            }
          ],
          'message': 'Success',
          'status': true
        };
        return ok(vendors);
      }

      // Get Manage Part Vendor for Cost Sourcing Tab
      if (request.url.endsWith('/get_manage_part_vendor') && request.method === 'POST') {
        if (request.body.state.skip === 1) {
        const vendors = {
          'vendors': [
            {
              'id': 3459,
              'vendorId': 34,
              'isPrimary': true,
              'memo': 'abc',
              'vendorPart': '86543',
              'cost': 15,
              'vendorName': 'qa',
              'msrp': 100,
              'multiplier': 0.6
            },
            {
              'id': 30265,
              'vendorId': 35,
              'isPrimary': false,
              'memo': 'abc',
              'vendorPart': '76543',
              'cost': 22,
              'vendorName': 'Vendor03',
              'msrp': 100,
              'multiplier': 0.6
            },
            {
              'id': 31244,
              'vendorId': 36,
              'isPrimary': false,
              'memo': 'abc',
              'vendorPart': '73827',
              'cost': 14,
              'vendorName': 'beeesolver',
              'msrp': 100,
              'multiplier': 0.6
            },
            {
              'id': 42420,
              'vendorId': 37,
              'isPrimary': false,
              'memo': 'abc',
              'vendorPart': '98767',
              'cost': 27,
              'vendorName': 'Vendor01',
              'msrp': 100,
              'multiplier': 0.6
            },
            {
              'id': 49196,
              'vendorId': 38,
              'isPrimary': false,
              'memo': 'abc',
              'vendorPart': '98766',
              'cost': 47,
              'vendorName': 'Vendor02',
              'msrp': 100,
              'multiplier': 0.6
            },
            {
              'id': 52037,
              'vendorId': 39,
              'isPrimary': false,
              'memo': 'abc',
              'vendorPart': '34567',
              'cost': 22,
              'vendorName': 'Vendor03',
              'msrp': 100,
              'multiplier': 0.6
            }
          ],
          'page': 1,
          'pageSize': 2147483647,
          'totalCount': 3352,
          'totalNumberOfPages': 1,
          'hasMore': false,
          'message': 'Success',
          'status': true
        };
        return ok(vendors);
        }

        const vendors = {
          'vendors': [
            {
              'id': 1234,
              'vendorId': 12,
              'isPrimary': false,
              'memo': 'abc',
              'vendorPart': '86543',
              'cost': 51,
              'vendorName': 'qa',
              'msrp': 100,
              'multiplier': 0.6
            },
            {
              'id': 6789,
              'vendorId': 13,
              'isPrimary': false,
              'memo': 'abc',
              'vendorPart': '76543',
              'cost': 52,
              'vendorName': 'Vendor03',
              'msrp': 100,
              'multiplier': 0.6
            },
            {
              'id': 31244,
              'vendorId': 14,
              'isPrimary': false,
              'memo': 'abc',
              'vendorPart': '73827',
              'cost': 53,
              'vendorName': 'beeesolver',
              'msrp': 100,
              'multiplier': 0.6
            },
            {
              'id': 42420,
              'vendorId': 15,
              'isPrimary': false,
              'memo': 'abc',
              'vendorPart': '98767',
              'cost': 17,
              'vendorName': 'Vendor501',
              'msrp': 100,
              'multiplier': 0.6
            },
            {
              'id': 49198766,
              'vendorId': 16,
              'isPrimary': false,
              'memo': 'abc',
              'vendorPart': '98766',
              'cost': 87,
              'vendorName': 'Vendor402',
              'msrp': 100,
              'multiplier': 0.6
            },
            {
              'id': 491987661,
              'vendorId': 17,
              'isPrimary': false,
              'memo': 'abc',
              'vendorPart': '98766',
              'cost': 87,
              'vendorName': 'Vendor302',
              'msrp': 100,
              'multiplier': 0.6
            },
            {
              'id': 491987662,
              'vendorId': 18,
              'isPrimary': false,
              'memo': 'abc',
              'vendorPart': '98766',
              'cost': 187,
              'vendorName': 'Vendor102',
              'msrp': 100,
              'multiplier': 0.6
            },
            {
              'id': 491987663,
              'vendorId': 19,
              'isPrimary': false,
              'memo': 'abc',
              'vendorPart': '98766',
              'cost': 87,
              'vendorName': 'Vendor202',
              'msrp': 100,
              'multiplier': 0.6
            },
            {
              'id': 491987664,
              'vendorId': 182,
              'isPrimary': false,
              'memo': 'abc',
              'vendorPart': '98766',
              'cost': 187,
              'vendorName': 'Vendor02',
              'msrp': 100,
              'multiplier': 0.6
            }
          ],
            'page': 1,
            'pageSize': 2147483647,
            'totalCount': 3352,
            'totalNumberOfPages': 1,
            'hasMore': true,
            'message': 'Success',
            'status': true
          };
          return ok(vendors);
      }


      if (request.url.endsWith('/Part_Task_Detail') && request.method === 'POST') {

        if (request.body.skip === 2) {
          const parttaskdetail = {
            'part_task_detail': [
              {
                'id': 3,
                'item': 'T5200003',
                'name': 'Expansion tank upto 50 gallon',
                'duration': 60.00,
                'trade': 'Hot Water',
                'value_rate': 366.89,
                'standard_rate': 366.89,
                'premium_rate': 366.89
              },
              {
                'id': 4,
                'item': 'T5200004',
                'name': 'Expansion tank upto 50 gallon',
                'duration': 60.00,
                'trade': 'Hot Water',
                'value_rate': 366.89,
                'standard_rate': 366.89,
                'premium_rate': 366.89
              }
            ],
            'page': 1,
            'pageSize': 2,
            'totalCount': 4,
            'totalNumberOfPages': 1,
            'hasMore': true,
            'message': 'Success',
            'status': true
          };

          return ok(parttaskdetail);
        }
        const parttaskdetail = {
          'part_task_detail': [
            {
              'id': 1,
              'item': 'T5200001',
              'name': 'Expansion tank upto 50 gallon',
              'duration': 60.00,
              'trade': 'Hot Water',
              'value_rate': 366.89,
              'standard_rate': 366.89,
              'premium_rate': 366.89
            },
            {
              'id': 2,
              'item': 'T5200002',
              'name': 'Expansion tank upto 50 gallon',
              'duration': 60.00,
              'trade': 'Hot Water',
              'value_rate': 366.89,
              'standard_rate': 366.89,
              'premium_rate': 366.89
            }
          ],
          'page': 1,
          'pageSize': 2,
          'totalCount': 4,
          'totalNumberOfPages': 1,
          'hasMore': true,
          'message': 'Success',
          'status': true
        };

        return ok(parttaskdetail);
      }

      if (request.url.endsWith('/Remove_Part_Task_Detail') && request.method === 'POST') {
        const removePartTaskDetail = {
          status: true,
          message: 'Removed Part Task Detail ',
          id: 92
        };

        return ok(removePartTaskDetail);
      }


      if (request.url.endsWith('/Toggle_Active_Part') && request.method === 'POST') {
        const removePartTaskDetail = {
          status: true,
          message: 'Part Activated ',
          id: 92
        };

        return ok(removePartTaskDetail);
      }

      if (request.url.endsWith('/updateallpartss') && request.method === 'POST') {
        const removePartTaskDetail = {
          status: true,
          message: 'Bulk Action Success',
          id: 92
        };

        return ok(removePartTaskDetail);
      }

      if (request.url.endsWith('/Copy_Part') && request.method === 'POST') {
        const copyPart = {
          status: true,
          message: 'Copied Part',
          id: 92
        };

        return ok(copyPart);
      }

      if (request.url.endsWith('/Save_Part') && request.method === 'POST') {
        const savePart = {
          status: true,
          message: 'Saved Part Successfully',
          id: 102
        };
        return ok(savePart);
      }

      if (request.url.endsWith('/remove_part_vendor') && request.method === 'POST') {
        const removePartVendor = {
          status: true,
          message: 'Removed Part Vendor ',
          id: 92
        };

        return ok(removePartVendor);
      }

      if (request.url.endsWith('/save_manage_part_vendor') && request.method === 'POST') {
        const savePartVendor = {
          status: true,
          message: 'Part vendor saved successfully',
          id: 102
        };

        return ok(savePartVendor);
      }

      if (request.url.endsWith('/save_manage_part_accounting') && request.method === 'POST') {
        const savePartAccount = {
          status: true,
          message: 'Part Accounting saved successfully',
          id: 108
        };

        return ok(savePartAccount);
      }


      if (request.url.endsWith('/remove_part_task_assignment') && request.method === 'POST') {
        const removePartVendor = {
          status: true,
          message: 'Removed Part Vendor ',
          id: 92
        };

        return ok(removePartVendor);
      }

      if (request.url.endsWith('/SearchProductLineForCompany') && request.method === 'POST') {
        if (request.body === 'a') {
          const productLineForCompany = {
            'productLineForCompany': [
              {
                'text': 'Acid Neutralizer(A/C Parts)',
                'value': '1043586'
              }
            ]
          };
          return ok(productLineForCompany);
        } else if (request.body === 'c') {
          const productLineForCompany = {
            'productLineForCompany': [
              {
                'text': 'Capacitor(A/C Parts)',
                'value': '1043635'
              },
              {
                'text': 'Capcity Booster(Water Closets & Urinals)',
                'value': '1043636'
              },
              {
                'text': 'CAPS(Capacitors)',
                'value': '985630'
              },
              {
                'text': 'CIF(Cast Iron Fittings)',
                'value': '985632'
              },
              {
                'text': 'Circuit Breaker(Electrical)',
                'value': '1043642'
              },
              {
                'text': 'Circulator(Boilers)',
                'value': '1043643'
              }
            ]
          };
          return ok(productLineForCompany);
        } else if (request.body === 'b') {
          const productLineForCompany = {
            'productLineForCompany': [
              {
                'text': 'BRKR(Circuit Breakers/Disconects)',
                'value': '985581'
              }
            ]
          };
          return ok(productLineForCompany);
        } else if (request.body === 'm') {
          const productLineForCompany = {
            'productLineForCompany': [
              {
                'text': 'MOT(Motors, Associated Items.)',
                'value': '985662'
              }
            ]
          };
          return ok(productLineForCompany);
        } else if (request.body === 'r') {
          const productLineForCompany = {
            'productLineForCompany': [
              {
                'text': 'Reducing Valve(Plumbing)',
                'value': '1043973'
              }
            ]
          };
          return ok(productLineForCompany);
        } else if (request.body === 's') {
          const productLineForCompany = {
            'productLineForCompany': [
              {
                'text': 'Special Order Part(Misc (Parts))',
                'value': '1180841'
              }
            ]
          };
          return ok(productLineForCompany);
        } else {
          const productLineForCompany = {
            'productLineForCompany': []
          };
          return ok(productLineForCompany);
        }
      }

      if (request.url.endsWith('/GetAllProductLineForCompany') && request.method === 'POST') {
        const productLineForCompany = {
          'productLineForCompany': [
            {
              'text': 'Special Order Part(Misc (Parts))',
              'value': '1180841'
            }
          ]
        };
        return ok(productLineForCompany);
      }

      if ((request.url.endsWith('/UpdateProductLineForCompany') && request.method === 'PUT')) {
        const updateProductLine = {
          status: true,
          message: 'Updated Successfully',
        };

        return ok(updateProductLine);
      }

      if (request.url.endsWith('/GetAllVendors') && request.method === 'GET') {
        const vendors = {
          'vendors': [
            {
                'id': 1,
                'name': 'Gunveer',
                'isTruckReplenishment': true,
                'isActive': true,
                'memo': 'abc',
                'firstName': 'Gunveer',
                'lastName': 'Singh',
                'email': 'gsingh@beesolver.com',
                'address': '40-A',
                'phone': '8956423614',
                'isDefault': true,
                'externalId': '1',
                'errorMessage': 'Success'
              },
              {
                'id': 2,
                'name': 'Ajay',
                'isTruckReplenishment': true,
                'isActive': true,
                'memo': 'abc',
                'firstName': 'Ajay',
                'lastName': 'Kumar',
                'email': 'akumar@beesolver.com',
                'address': '40-A',
                'phone': '8956343614',
                'isDefault': true,
                'externalId': '2',
                'errorMessage': 'Success'
              },
              {
                'id': 3,
                'name': 'Brij',
                'isTruckReplenishment': true,
                'isActive': true,
                'memo': 'abc',
                'firstName': 'Brij',
                'lastName': 'Mohan',
                'email': 'bmohan@beesolver.com',
                'address': '40-A',
                'phone': '8956233614',
                'isDefault': true,
                'externalId': '3',
                'errorMessage': 'Success'
              },
              {
                'id': 4,
                'name': 'Gunveer1',
                'isTruckReplenishment': true,
                'isActive': true,
                'memo': 'abc',
                'firstName': 'Gunveer1',
                'lastName': 'Singh1',
                'email': 'gsingh1@beesolver.com',
                'address': '40-A',
                'phone': '8956423614',
                'isDefault': true,
                'externalId': '4',
                'errorMessage': 'Success'
              },
              {
                'id': 5,
                'name': 'Gunveer2',
                'isTruckReplenishment': true,
                'isActive': true,
                'memo': 'abc',
                'firstName': 'Gunveer2',
                'lastName': 'Singh2',
                'email': 'gsingh@beesolver.com',
                'address': '40-A',
                'phone': '8952223614',
                'isDefault': true,
                'externalId': '5',
                'errorMessage': 'Success'
              },
              {
                'id': 6,
                'name': 'Gunveer6',
                'isTruckReplenishment': true,
                'isActive': true,
                'memo': 'abc',
                'firstName': 'Gunveer6',
                'lastName': 'Singh6',
                'email': 'gsingh6@beesolver.com',
                'address': '40-A',
                'phone': '8956423614',
                'isDefault': true,
                'externalId': '6',
                'errorMessage': 'Success'
              },
              {
                'id': 7,
                'name': 'Gunveer7',
                'isTruckReplenishment': true,
                'isActive': true,
                'memo': 'abc',
                'firstName': 'Gunveer7',
                'lastName': 'Singh7',
                'email': 'gsingh@beesolver.com',
                'address': '40-A',
                'phone': '8956423614',
                'isDefault': true,
                'externalId': '7',
                'errorMessage': 'Success'
              },
              {
                'id': 8,
                'name': 'Gunveer8',
                'isTruckReplenishment': true,
                'isActive': true,
                'memo': 'abc',
                'firstName': 'Gunveer8',
                'lastName': 'Singh8',
                'email': 'gsingh8@beesolver.com',
                'address': '40-A',
                'phone': '8956423614',
                'isDefault': true,
                'externalId': '8',
                'errorMessage': 'Success'
              }
          ]
        };
        return ok(vendors);
      }

      if (request.url.endsWith('/AddVendor') && request.method === 'POST') {
        const addVendor = {
          status: true,
          message: 'Vendor successfully assigned',
          id: request.body
        };

        return ok(addVendor);
      }

      // Get Login Page Html
      if (request.url.endsWith('/home/getloginpagehtml') && request.method === 'GET') {
        return this._http.get('./assets/html/get-login-page.html', { responseType: 'text' }).pipe(map((res) => {
          return new HttpResponse({
            status: 200, body: {
              Status: true,
              Message: 'Success',
              ReturnData: {
                isHtml: false,
                isImage: false,
                isBinary: false,
                imageBytes: 'data:image/png;base64,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',
                imageUrl: 'http://qa1.profitrhino.com/Content/Company/Images/transparent_login.png',
                content: res
              }
            }
          });
        }));
      }

      // get user by id - admin or user (user can only access their own record)
      if (request.url.match(/\/users\/\d+$/) && request.method === 'GET') {
        if (!isLoggedIn) { return unauthorised(); }

        // get id from request url
        const urlParts = request.url.split('/');
        const id = parseInt(urlParts[urlParts.length - 1], 10);

        // only allow normal users access to their own record
        const user = users.find(x => x.id === id);
        return ok(user);
      }

      // get all users (admin only)
      if (request.url.endsWith('/users') && request.method === 'GET') {
        return ok(users);
      }

      // pass through any requests not handled above
      return next.handle(request);
    })
    )
      // call materialize and dematerialize to ensure delay even if an error is thrown (https://github.com/Reactive-Extensions/RxJS/issues/648)
      .pipe(materialize())
      .pipe(delay(500))
      .pipe(dematerialize());

    // private helper functions
    function ok(data) {
      return of(new HttpResponse({
        status: 200, body: {
          Status: true,
          Message: 'Success',
          ReturnData: data
        }
      }));
    }

    function unauthorised() {
      return throwError({ status: 401, error: { message: 'Unauthorised' } });
    }

    function error(message) {
      return throwError({ status: 400, error: { message } });
    }
  }
}

export let fakeBackendProvider = {
  // use fake backend in place of Http service for backend-less development
  provide: HTTP_INTERCEPTORS,
  useClass: FakeBackendInterceptor,
  multi: true
};
